module.exports = __webpack_public_path__ + "img/tv.be5919c3.svg";